import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-main-store-inactive-variants-with-stock-chart',
    templateUrl: './main-store-inactive-variants-with-stock-chart.component.html',
    styleUrl: './main-store-inactive-variants-with-stock-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MainStoreInactiveVariantsWithStockChartComponent {

}
